export default {
  SET_CLIENT_USERS(state, client_users) {
    state.client_users = client_users
  },
  REMOVE_ACCOUNT(state, itemId) {
      const accountIndex = state.client_users.datas.findIndex((u) => u.id == itemId)
      state.client_users.datas.splice(accountIndex, 1)
  },
  SELECTED_ACCOUNT(state,data){
    state.client_users.datas = []
    state.client_users.total = 1;
    state.client_users.per_page = 1;
    state.client_users.datas.push(data)
  },
  SET_PHONE_TYPES(state,phone_types){
    state.phone_types = phone_types
  },
  SET_CLIENT_ROLE_TYPES(state,client_role_types){
    state.client_role_types = client_role_types
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  SET_VERTICALS(state,data){
    state.verticals = data
  },
  SET_COUNTRIES(state,data){
    state.countries = data
  },
  SET_CLIENT_USER(state,data){
    state.client_user = data
  },
  EDIT_ITEM(state,data){
    state.client_user = data
  },
  ADD_ITEM(state,data){
    state.client_user = data
  },
  SET_CLIENT_USER_STATUS(state,client_user_status){
    state.client_user_status = client_user_status
  }
}
